import styled from '@emotion/styled';
import { colors } from 'theme/colors';

interface IStyledSearchWrapper {
  padding: string | undefined;
  margin: string | undefined;
}

export const StyledSearchWrapper = styled.div<IStyledSearchWrapper>`
  background-color: ${colors.gray50};
  border: 1px solid ${colors.gray100};
  border-radius: 4px;
  ${(props: IStyledSearchWrapper) => `
      padding: ${props.padding ? props.padding : '20px'};
  `}
  ${(props: IStyledSearchWrapper) => `
      margin: ${props.margin ? props.margin : ''};
  `}
`;
